module.exports = __webpack_public_path__ + "static/media/booth_bg.0663b893.jpg";